import React, { useEffect, useMemo, useState, useCallback } from "react";
import { debounce } from "../../commonFunctions/arrayFunc";
import ClassSelectorLayout from "../ClassSelectorLayout/ClassSelectorLayout";

const EditMultiPositionFields = ({ type, handleClasses }) => {
  const [appliedClasses, setAppliedClasses] = useState([]);

  // Memoized debounced callback that depends on handleClasses
  const debouncedHandleClasses = useMemo(() => {
    const debouncedFn = debounce((cls) => {
      handleClasses(cls);
    }, 300);

    return debouncedFn;
  }, [handleClasses]);

  // Apply debounced call on class changes
  useEffect(() => {
    if (appliedClasses.length) {
      debouncedHandleClasses(appliedClasses);
    }

    return () => {
      debouncedHandleClasses.cancel?.();
    };
  }, [appliedClasses, debouncedHandleClasses]);

  // Prevent unnecessary updates
  const handleChange = useCallback((newClasses) => {
    setAppliedClasses(newClasses);
  }, []);

  return (
    <div>
      <ClassSelectorLayout defaultSelected={appliedClasses} onChange={handleChange} type={type} />
    </div>
  );
};

export default EditMultiPositionFields;
